module.exports = __webpack_public_path__ + "static/img/bg2.a5d0f887.png";